import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntlTelInputComponent } from './intlTelInput.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [IntlTelInputModule.rootComponent],
  imports: [CommonModule, FormsModule],
  exports: [IntlTelInputModule.rootComponent],
  entryComponents: [IntlTelInputModule.rootComponent],
})
export class IntlTelInputModule {
  static rootComponent = IntlTelInputComponent;
}
